import {createUseStyles} from 'react-jss';
import loadArtemisFonts from '../../v2/components/ui/loadArtemisFonts';
import isUsingArtemisStyles from '../../v2/selectors/isUsingArtemisStyles';
import MediaQueries from '../../v2/style-helper/MediaQueries';
import Typography from '../../v2/style-helper/Typography';

export default createUseStyles({
  header: {
    borderTop: 'solid 1px #ccc',
    borderBottom: props => props.collapsed && 'solid 1px #ccc',
    marginBottom: props => !props.collapsed && 22,
    transition: 'border-bottom 0.3s ease 0.4s',
  },
  button: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: [16, 0],
    fontSize: 28,
    textTransform: 'none',
    textDecoration: 'none',
    fontWeight: 700,
    textAlign: 'left',
    color: '#4d5053',
    
    '&:hover, &:active, &:focus': {
      color: '#4d5053',
    },
    
    extend: props => ({
      ...(isUsingArtemisStyles && props.theme.typography?.[Typography.medium])
      && loadArtemisFonts(props.theme.typography[Typography.large1], true),
    }),
  
    [MediaQueries.phone]: {
      fontSize: 24,
      justifyContent: 'space-between',
    },
  },
  icon: {
    margin: [0, 25],
    transition: 'transform 0.4s',
    transform: props => !props.collapsed && 'rotate(-180deg)',
  
    [MediaQueries.phone]: {
      margin: [0, 10],
    },
  },
  panel: {
    lineHeight: 1.4,
    position: 'relative',
    overflow: 'hidden', // Prevent panel header overflowing rounded corners
    transition: 'max-height 0.5s, opacity 0.3s',
    maxHeight: props => (props.collapsed ? 0 : 600),
    opacity: props => (props.collapsed ? 0 : 1),
  
    [MediaQueries.phone]: {
      maxHeight: props => (props.collapsed ? 0 : 1300),
    },
  },
});
